export function isMyCard(cardId = "", businessCards = []) {
  if (!cardId || !businessCards || !businessCards.length) return false;

  return businessCards.includes(cardId);
}
